// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationController from "./application_controller"
application.register("application", ApplicationController)

import AppointmentsController from "./appointments_controller"
application.register("appointments", AppointmentsController)

import BindingController from "./binding_controller"
application.register("binding", BindingController)

import CalendarController from "./calendar_controller"
application.register("calendar", CalendarController)

import CommitmentsController from "./commitments_controller"
application.register("commitments", CommitmentsController)

import CoverDisplayController from "./cover_display_controller"
application.register("cover-display", CoverDisplayController)

import CoversController from "./covers_controller"
application.register("covers", CoversController)

import DocumentsController from "./documents_controller"
application.register("documents", DocumentsController)

import DropdownsController from "./dropdowns_controller"
application.register("dropdowns", DropdownsController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import FlooredGroupsController from "./floored_groups_controller"
application.register("floored-groups", FlooredGroupsController)

import HoverOverController from "./hover_over_controller"
application.register("hover-over", HoverOverController)

import ImagePickerController from "./image_picker_controller"
application.register("image-picker", ImagePickerController)

import LeafletController from "./leaflet_controller"
application.register("leaflet", LeafletController)

import LightgalleryController from "./lightgallery_controller"
application.register("lightgallery", LightgalleryController)

import MarketController from "./market_controller"
application.register("market", MarketController)

import MarketMapController from "./market_map_controller"
application.register("market-map", MarketMapController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NfcWriterController from "./nfc_writer_controller"
application.register("nfc-writer", NfcWriterController)

import OrdersController from "./orders_controller"
application.register("orders", OrdersController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SlideOverController from "./slide_over_controller"
application.register("slide-over", SlideOverController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SpecialPricingController from "./special_pricing_controller"
application.register("special-pricing", SpecialPricingController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TinySliderController from "./tiny_slider_controller"
application.register("tiny-slider", TinySliderController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TurboActiveLinkController from "./turbo_active_link_controller"
application.register("turbo-active-link", TurboActiveLinkController)

import UppyController from "./uppy_controller"
application.register("uppy", UppyController)
